import React, { useState, useEffect } from 'react';
import MenuFilter from './MenuFilter'
import MenuList from './MenuList'
import { withMenuConsumer } from '../context'
import Loading from './Loading'

function MenuContainer({ context }) {

    const { loading, sortedMenu, menu } = context;


    if (loading) {
        return <Loading />;
    }
    return (
        <>
            <MenuFilter menu={menu} />
            <MenuList menu={sortedMenu} />
        </>
    );
}

export default withMenuConsumer(MenuContainer);
